import {
    REQUEST_SUCCESS,
    REQUEST_FAILURE,
    REQUEST_LOADING,
    RESET_REQUEST_STATE,
    SET_CARD_INSIGHT_METADATA,
    OPEN_KNOWLEDGE_CENTER,
    CLOSE_KNOWLEDGE_CENTER,
    KNOWLEDGE_CENTER_STATE_KEY,
} from '../../actions/actionTypes';

const initialState: any = {
};

const commonReducer = (
    state = initialState,
    action: { type: string; payload?: any; key: string }
): any => {
    switch (action.type) {
        case REQUEST_LOADING:
            return {
                ...state,
                [action?.key]: action.payload,
            };
        case REQUEST_FAILURE:
            return {
                ...state,
                [action?.key]: action.payload,
            };
        case REQUEST_SUCCESS:
            return {
                ...state,
                [action?.key]: action.payload,
            };
        case SET_CARD_INSIGHT_METADATA:
            return {
                ...state,
                [action?.key]: action.payload,
            };
        case OPEN_KNOWLEDGE_CENTER:
            return {
                ...state,
                [action?.key || KNOWLEDGE_CENTER_STATE_KEY]: action.payload,
            };
        case CLOSE_KNOWLEDGE_CENTER:
            return {
                ...state,
                [action?.key || KNOWLEDGE_CENTER_STATE_KEY]: action.payload,
            };
        case RESET_REQUEST_STATE: {
            // Reset specified keys to their initial values
            const newState = { ...state };
            (action.payload || []).forEach((key: string) => {
                delete newState[key];
                // Also delete the loading and error variants
                delete newState[`${key}Loading`];
                delete newState[`${key}Error`];
            });
            return newState;
        }

        default:
            return state;
    }
};

export default commonReducer;
